import React, { useEffect, useState } from "react";

import { useLocation, useHistory } from 'react-router-dom'

// redux
import { connect } from "react-redux";

// react router
import { Link } from "react-router-dom";

// icon
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { MdCancel } from "react-icons/md";

// styles
import {
	ProductListContainer,
	FilterContainer,
	P,
	ProductsContainer,
	ProductInfo,
	ProductLink,
	ProductDetail,
	ProductImageContainer,
	ProductImage,
	ProductPrice,
	ButtonContainer,
	Button,
	DropdownContainer,
	DropDownList,
} from "../../styles/ProductList";

// no image
import noImgFoundImg from 'assets/images/no-img.png'

// loading
import LoadingSkeleton from "./ProductList__loadingSkeleton";

// custom hooks
import useQueryHook from 'utlis/CustomHooks/useQueryHook';

// filters view
import FiltersView from "./includes/FiltersView";

function ProductList(props) {
	// props
	const {
		allProductsLoading,
		allProducts,
		allProductsImages,

		onFilterChangeTriggered,
		handleRemoveFilter,
		handleResetAllFilters,

		filtersList,
		appliedFilters,
	} = props;

	// consts
	const loadingIndicatorsCount = [1, 2, 3, 4, 5, 6, 7, 8, 9]
	const location = useLocation()
	const history = useHistory()
	const query = useQueryHook()

	// states
	const [isOpenFilters, setIsOpenFilters] = useState(false);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	const [currentFilterOpened, setCurrentFilterOpened] = useState([])

	// handle sort order
	const handleSortOrder = (ev, sortType) => {
		ev.preventDefault()

		if (sortType) { // if sort order exist
			setIsDropdownOpen(false) // closing the dropdown

			const locationSearch = location?.search

			if (locationSearch) {
				if (location.search.search("sort") !== -1) { // if sort order already exist in the query params
					// const sortVal = query.get("sort")
					const splittedValue = locationSearch.split("&") // converting search to arrays

					let updateValues = []
					splittedValue.forEach(item => {
						if (item.search("sort=") === -1) {
							updateValues.push(item)
						}
					})

					// const finalValue = updateValues.join("&") + "&sort=" + (sortVal + "|" + sortType)
					const finalValue = updateValues.join("&") + "&sort=" + sortType

					history.push({ // changing the url
						pathname: location.pathname,
						search: finalValue
					})
				} else { // if no sort order exist in the query params
					let search = ""
					search = location.search + "&sort=" + sortType

					history.push({
						pathname: location.pathname,
						search
					})
				}
			}
		}
	}

	return (
		<ProductListContainer>
			{
				allProductsLoading ? (
					<div className="loading-container row">
						{
							(loadingIndicatorsCount?.length) ? loadingIndicatorsCount.map(item => (
								<React.Fragment key={item}>
									<LoadingSkeleton />
								</React.Fragment>
							)) : null
						}
					</div>
				) : (
					<React.Fragment>
						{/* top view */}
						<FilterContainer>
							{/* <P className="cursor-pointer mb-0 text-uppercase d-flex align-items-center" onClick={() => setIsOpenFilters((Previous) => !Previous)}>
								<span>
									{
										!isOpenFilters ? (
											<React.Fragment>
												Filters
											</React.Fragment>
										) : (
											<React.Fragment>
												Hide Filters
											</React.Fragment>
										)
									}
								</span>
								{
									!isOpenFilters ? (
										<BiChevronDown
											style={{ height: "25px", width: "25px", color: "#757575" }}
										/>
									) : (
										<BiChevronUp
											style={{ height: "25px", width: "25px", color: "#757575" }}
										/>
									)
								}
							</P> */}

							<div className="dropdown-outer position-relative ms-auto" onClick={ev => ev.stopPropagation()}>
								<P className="cursor-pointer mb-0 text-uppercase d-flex align-items-center" onClick={() => setIsDropdownOpen((Previous) => !Previous)}>
									Sort By
									{
										isDropdownOpen ? (
											<BiChevronDown
												style={{ height: "25px", width: "25px", color: "#757575" }}
											/>
										) : (
											<BiChevronUp
												style={{ height: "25px", width: "25px", color: "#757575" }}
											/>
										)
									}
								</P>
								{
									isDropdownOpen && (
										<DropdownContainer>
											<DropDownList
												className="m-0 cursor-pointer"
												onClick={ev => handleSortOrder(ev, "AtoZ")}
											>
												A to Z
											</DropDownList>
											<DropDownList
												className="m-0 cursor-pointer"
												onClick={ev => handleSortOrder(ev, "priceLowToHigh")}
											>
												Price, low to high
											</DropDownList>
											<DropDownList
												className="m-0 cursor-pointer"
												onClick={ev => handleSortOrder(ev, "priceHighToLow")}
											>
												Price, high to low
											</DropDownList>
											<DropDownList
												className="m-0 cursor-pointer"
												onClick={ev => handleSortOrder(ev, "new")}
											>
												New
											</DropDownList>
										</DropdownContainer>
									)
								}
							</div>
						</FilterContainer>

						{/* product list container */}
						<div className="row align-items-start">
							{/* filter */}
							{
								isOpenFilters ? (
									<FiltersView
										onFilterChangeTriggered={onFilterChangeTriggered}

										filtersList={filtersList}

										currentFilterOpened={currentFilterOpened}
										setCurrentFilterOpened={setCurrentFilterOpened}
									/>
								) : null
							}

							{/* listing */}
							<ProductsContainer className={`col`}>
								{
									/* applied filters */
									appliedFilters?.length ? (
										<div className="applied-filters col-12 mb-3">
											<div className="inner d-flex flex-wrap">
												{
													/* filter item */
													appliedFilters.map(item => (
														<div key={item.id} className="filter-item d-flex align-items-center me-2">
															<p className="mb-0 me-1">{item.name}</p>
															<div
																className="icon cursor-pointer"
																title="Remove Filter"
																onClick={ev => handleRemoveFilter(ev, item.id)}>
																<MdCancel />
															</div>
														</div>
													))
												}

												<div className="clear-all">
													<a
														href="/"
														className="text-decoration-underline st-text-primary st-fs-13"
														onClick={handleResetAllFilters}
													>Clear All</a>
												</div>
											</div>
										</div>
									) : null
								}

								{
									allProducts?.length ? allProducts.map(item => {
										return (
											<div key={item.product_id} className={`col-sm-6 col-lg-4`}>
												<ProductInfo>
													<ProductLink>
														<ProductImageContainer>
															<Link to={`/product/${item.product_url}?id=${item.product_id}`} className="text-decoration-none d-block">
																<ProductImage
																	src={allProductsImages[item.product_id]?.main_thumb?.small || noImgFoundImg}
																	onLoad={ev => ev.target.parentNode.classList.add("loaded")}
																/>
															</Link>
														</ProductImageContainer>

														<Link to={`/product/${item.product_url}?id=${item.product_id}`} className="text-decoration-none d-block">
															<ProductDetail>{item.product_name}</ProductDetail>
														</Link>

														<ProductPrice>${item.price.toFixed(2)}</ProductPrice>

														<ButtonContainer>
															<Link
																to={`/product/${item.product_url}?id=${item.product_id}`}
																className={`text-decoration-none d-inline-block ${(item.stock === 0) ? "disabled" : ""}`}>
																<Button disabled={item.stock === 0} className={`${(item.stock === 0) ? "disabled btn-dark" : ""}`}>
																	{
																		(item.stock === 0) ? (
																			"Out Of Stock"
																		) : "Buy Now"
																	}
																</Button>
															</Link>
														</ButtonContainer>
													</ProductLink>
												</ProductInfo>
											</div>
										);
									}) : (
										<React.Fragment>
											<div className="text-center py-2">
												No product found
											</div>
										</React.Fragment>
									)
								}
							</ProductsContainer>
						</div>
					</React.Fragment>
				)
			}
		</ProductListContainer>
	);
}


export default connect(null, null)(ProductList);